import { Component } from '@theme/component';

/**
 * Handles variant option links on product cards (collection, home, product recommendations).
 *
 * @extends {Component}
 */
export class VariantWeightAddButtons extends Component {
  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    super.connectedCallback();

    if (!this.closest('product-card')) return;

    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.addEventListener('click', this.#handleClick, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
  }

  /**
   * Lets variant option links navigate to the product page while preventing card navigation on empty areas.
   * @param {Event} event
   */
  #handleClick = (event) => {
    const optionLink = event.target.closest('a.variant-weight-add-buttons__option');

    if (optionLink instanceof HTMLAnchorElement) {
      event.stopPropagation();
    }
  };
}

if (!customElements.get('variant-weight-add-buttons')) {
  customElements.define('variant-weight-add-buttons', VariantWeightAddButtons);
}
